import { render } from 'react-dom';
import { RhumbProvider } from 'react-rhumb';
import staticAdapter from 'react-rhumb/staticAdapter';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import Raven from 'raven-js';
import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import UIApplication from 'UIComponents/app/UIApplication';
// @ts-expect-error Not converted yet
import { getShouldSendCallback } from 'ContentUtils/helpers/sentry';
import { reportError } from 'FileManagerCore/utils/logging';
import Page from './components/Page';
import rhumbConfig from '../rhumb-config.yaml';
import { jsx as _jsx } from "react/jsx-runtime";
const FILE_PREVIEW_ID_MATCHER = new RegExp(`file-preview/${PortalIdParser.get()}/file/(\\d+)/?`, 'i');
export default class Application {
  constructor() {
    this.startApp = () => {
      const matches = FILE_PREVIEW_ID_MATCHER.exec(window.location.pathname);
      if (matches && matches.length === 2) {
        const fileId = String(matches[1]);
        render( /*#__PURE__*/_jsx(RhumbProvider
        //@ts-expect-error Types for rhumbConfig not inferring properly
        , {
          config: rhumbConfig,
          history: staticAdapter('/'),
          children: /*#__PURE__*/_jsx(UIApplication, {
            name: "FileManagerPreview",
            children: /*#__PURE__*/_jsx(Page, {
              fileId: fileId
            })
          })
        }), document.getElementsByClassName('page')[0]);
      }
    };
  }
  start() {
    window.AppInstance = this;
    Raven.setShouldSendCallback(getShouldSendCallback);
    this.init().then(this.startApp).catch(error => {
      reportError(error);
    });
  }
  init() {
    return userInfo().then(({
      user,
      portal
    }) => {
      Raven.setUserContext({
        id: user.user_id.toString(),
        email: user.email,
        //@ts-expect-error Raven does not have type for locale key
        locale: user.locale
      });
      return BasicI18nSetup.setup({
        lang,
        user,
        portal
      });
    });
  }
}